import React from 'react';
import { Card, Descriptions, Space } from 'antd';
import PropTypes from 'prop-types';
import { formatEnum, isEmpty } from 'utils';
import { FileList, DateDisplay } from 'components/layout';
import { ENUM_PROPOSAL_REVISION_CHANGES_INCLUDED } from 'constants/form';

const changesIncludedContent = (changesIncluded) => {
  console.log(isEmpty(changesIncluded));
  return !isEmpty(changesIncluded) ? (
    <Space direction="vertical">
      {changesIncluded.map((change) => (
        <div key={change}>
          {ENUM_PROPOSAL_REVISION_CHANGES_INCLUDED[change]}
        </div>
      ))}
    </Space>
  ) : (
    ' - '
  );
};

const ProposalRevisionDetail = ({ data, title, confirm }) => {
  const proposalRevision = data.proposalRevisions[0];

  return (
    <Card title={title}>
      <Descriptions column={3}>
        {!confirm && (
          <>
            <Descriptions.Item label="Application Date" span={1}>
              <DateDisplay date={proposalRevision.date} />
            </Descriptions.Item>
            <Descriptions.Item label="Status" span={2}>
              {formatEnum(proposalRevision.status)}
            </Descriptions.Item>
          </>
        )}
        <Descriptions.Item label="Revised Proposal" span={3}>
          <FileList files={[proposalRevision.revisedProposal]} />
        </Descriptions.Item>
        <Descriptions.Item label="Support Document(s)" span={3}>
          <FileList files={proposalRevision.supportingDocuments} />
        </Descriptions.Item>
        <Descriptions.Item label="Changes included" span={3}>
          {changesIncludedContent(proposalRevision.changesIncluded)}
        </Descriptions.Item>
        <Descriptions.Item label="Highlights of Change" span={3}>
          {proposalRevision.highlights}
        </Descriptions.Item>
        <Descriptions.Item label="Justification" span={3}>
          {proposalRevision.justification}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

ProposalRevisionDetail.defaultProps = {
  data: {
    proposalRevisions: [],
  },
  title: 'Proposal Revision Detail',
  confirm: false,
};

ProposalRevisionDetail.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  confirm: PropTypes.bool.isRequired,
};

export default ProposalRevisionDetail;
